module.exports = __webpack_public_path__ + "static/media/MSS_equipe.ab14c0a3.png";